module.exports = __webpack_public_path__ + "static/media/S3_04.45462136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE3strobe/S3_04.png
// module id = 198
// module chunks = 0